import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Set value on given path. If value is undefined, then delete property on path. Path must be defined, otherwise same state will be returned.
 * @param state {Object}
 * @param path {Array}
 * @param value {*}
 * @return {Object}
 */
function setHelper(state, path, value) {
  if (state && path) {
    var remainingPath = _toConsumableArray(path);

    var currentKey = remainingPath.shift();

    if (remainingPath.length) {
      return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, currentKey, setHelper(state[currentKey], remainingPath, value)));
    }

    if (currentKey === '') {
      return _objectSpread({}, state);
    } else {
      if (typeof value === 'undefined') {
        delete state[currentKey];
        return _objectSpread({}, state);
      } else {
        return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, currentKey, value));
      }
    }
  } else {
    return state;
  }
}

export default {
  setHelper: setHelper
};